<template>
  <div v-if="displayPreLife">
    <StartQuoteStepperWidget v-if="displayQuoteStepper" />
    <QuoteStepper
      :is-mobile="isMobile"
      v-if="displayQuotes"
      :quotes="quotes"
      :completed-quote="completedQuote"
      :quotes-errors="quotesErrors"
      :error-img="images.quoteError"
      :quotes-loading="quotesLoading"
      :org-contact-phone="orgContactPhone"
      @open="$emit('open:quote', $event)"
    />
    <div v-if="displaySettlement" class="q-mx-md">
      <div class="row justify-center">
        <SAISpinner v-if="hasQuoteLoading || settlementLoading" />
      </div>
      <div id="settlement-app" />
    </div>
  </div>
</template>

<script>
import { SAISpinner } from 'ecx.saigon.ui.common';

export default {
  name: 'PreLifeDashboard',
  props: {
    displayPreLife: Boolean,
    isMobile: Boolean,
    displayQuoteStepper: Boolean,
    displayQuotes: Boolean,
    settlementLoading: Boolean,
    hasQuoteLoading: Boolean,
    completedQuote: String,
    quotesErrors: {
      type: Object,
      default: () => ({})
    },
    quotesLoading: {
      type: Object,
      default: () => ({})
    },
    orgContactPhone: String,
    displaySettlement: Boolean,
    images: {
      type: Object,
      default: () => ({})
    },
    quotes: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SAISpinner,
    StartQuoteStepperWidget: () =>
      import('../../../widgets/start-quote-stepper'),
    QuoteStepper: () => import('../../molecule/quote-stepper')
  }
};
</script>
